import { queryOptions } from "@tanstack/react-query";
import { axiosInstance } from "../axios";
import { AdminUser, FeatureFlagRoleBinding, GrantRoleRequest, RevokeRoleRequest } from "./admin.types";

export const adminApi = {
    listUsers: async (email?: string): Promise<AdminUser[]> => {
        const response = await axiosInstance.get<AdminUser[]>("/admin/users", {
            params: email ? { email } : undefined,
        });
        return response.data;
    },

    grantRole: async (request: GrantRoleRequest) => {
        const response = await axiosInstance.post("/admin/users/roles/grant", request);
        return response.data;
    },

    revokeRole: async (request: RevokeRoleRequest) => {
        await axiosInstance.post("/admin/users/roles/revoke", request);
    },

    listFeatureFlagRoleBindings: async (): Promise<FeatureFlagRoleBinding[]> => {
        const response = await axiosInstance.get<FeatureFlagRoleBinding[]>("/admin/feature-flags");
        return response.data;
    },

    bindFeatureFlagRole: async (featureFlagId: number, roleName: string) => {
        await axiosInstance.post(`/admin/feature-flags/${featureFlagId}/roles/${encodeURIComponent(roleName)}`);
    },

    unbindFeatureFlagRole: async (featureFlagId: number, roleName: string) => {
        await axiosInstance.delete(`/admin/feature-flags/${featureFlagId}/roles/${encodeURIComponent(roleName)}`);
    },
};

export const adminUsersQueryOptions = (email?: string) =>
    queryOptions({
        queryKey: ["admin", "users", email ?? ""],
        queryFn: () => adminApi.listUsers(email),
    });

export const adminFeatureFlagBindingsQueryOptions = queryOptions({
    queryKey: ["admin", "feature-flags"],
    queryFn: adminApi.listFeatureFlagRoleBindings,
});
